import { TriggerTypes } from "@enums/trigger-types";

export const CONDITION_TRIGGER_OPTIONS = [
    {
        label: "Assertion",
        value: TriggerTypes.ASSERTION
    },
    {
        label: "User Input",
        value: TriggerTypes.USER_INPUT
    },
    {
        label: "Acquired Data",
        value: TriggerTypes.ACQUIRED_DATA
    },
    {
        label: "Component",
        value: TriggerTypes.COMPONENT
    }
]